const scriptDataList = [];

export function insertScript(id, url) {
  const scriptData = scriptDataList.find(item => item.id === id);
  if (scriptData) {
    return scriptData.promise;
  }
  const promise = new Promise(function (resolve, reject) {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'text/javascript';
      el.src = url;
      document.documentElement.appendChild(el);
    } else {
      resolve();
    }
    el.onload = function () {
      resolve();
    };
    el.onerror = function (msg) {
      reject(new Error(msg));
    };
  });
  scriptDataList.push({ id, promise });
  return promise;
}

/**
 * @name 获取url请求参数
 * @param {string} search
 */
export const getURLSearchParams = () => {
  let ret = {};
  const arr = window.location.href.split('?');
  if (arr[1]) {
    let searchParams = new URLSearchParams(arr[1]);
    for (let [key, value] of searchParams) {
      ret[key] = value;
    }
  }

  return ret;
};
